import { useEffect, useRef } from "react";
import { Box, Button, Modal, Stack, Typography } from "@mui/material";
import lottie from "lottie-web";

const BookingSuccessAnimation = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current) return undefined;

    const animation = lottie.loadAnimation({
      container: containerRef.current,
      renderer: "svg",
      loop: false,
      autoplay: true,
      path: `${process.env.PUBLIC_URL}/assets/raw/check_success.json`,
    });

    return () => animation.destroy();
  }, []);

  return <Box ref={containerRef} sx={{ width: 150, height: 150 }} />;
};

const BookingSuccessModal = ({
  open,
  message,
  orderCounter,
  onClose,
  onViewHistory,
}) => (
  <Modal open={open} onClose={onClose} aria-labelledby="booking-success-title">
    <Box
      sx={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: {
          xs: "88%",
          sm: 420,
        },
        bgcolor: "background.paper",
        borderRadius: "8px",
        boxShadow: 24,
        p: 3,
        outline: "none",
      }}
    >
      <Stack spacing={2} alignItems="center" textAlign="center">
        <BookingSuccessAnimation />
        <Typography
          id="booking-success-title"
          variant="h6"
          sx={{ fontWeight: "bold" }}
        >
          {message}
        </Typography>
        <Typography variant="body1" sx={{ fontWeight: 600 }}>
          Numero de Pedido: {orderCounter}
        </Typography>
        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={1}
          sx={{ width: "100%", pt: 1 }}
        >
          <Button fullWidth variant="contained" onClick={onViewHistory}>
            Ver Historial
          </Button>
          <Button fullWidth variant="outlined" color="warning" onClick={onClose}>
            Aceptar
          </Button>
        </Stack>
      </Stack>
    </Box>
  </Modal>
);

export default BookingSuccessModal;
